module.exports = __webpack_public_path__ + "static/media/Angle-down.98b954bd.svg";